(function() {
  var config = window.petaSearchIndexConfig || {};
  var products = null;
  var loadingPromise = null;
  var renderToken = 0;
  var productDetailCache = {};
  var fallbackRefreshSearch = window.petaRefreshSearchRecommendedSort;
  var PRODUCTS_PER_PAGE = Number(config.productsPerPage || 24);
  var QUERY_FIELD_PREFIX = /\b(?:tag|title|body|vendor|product_type|variants\.sku):/gi;

  function normalize(value) {
    var text = String(value || '');
    if (typeof text.normalize === 'function') text = text.normalize('NFKC');
    return text
      .replace(/カッコイイ|カッコいい|かっこ良い|かっこよい|格好いい|格好良い|格好よい/g, 'かっこいい')
      .toLowerCase()
      .replace(/\u3000/g, ' ')
      .replace(/[・･／/_-]/g, '')
      .replace(/[()（）「」『』【】［］\[\]{}"'“”‘’.,，、。:：;；!?！？]/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function compact(value) {
    return normalize(value).replace(/\s+/g, '');
  }

  function escapeHtml(value) {
    return String(value || '').replace(/[&<>"']/g, function(character) {
      return {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#39;',
      }[character];
    });
  }

  function escapeAttr(value) {
    return escapeHtml(value);
  }

  function currentParams() {
    return new URLSearchParams(window.location.search);
  }

  function unquoteFieldValue(value) {
    return String(value || '').trim().replace(/^"|"$/g, '');
  }

  function fieldValues(rawQuery, fieldName) {
    var values = [];
    var regex = new RegExp('(?:^|[\\s(])' + fieldName.replace('.', '\\.') + ':("[^"]+"|[^\\s)]+)', 'gi');
    var match;
    while ((match = regex.exec(String(rawQuery || ''))) !== null) {
      var value = unquoteFieldValue(match[1]);
      if (value && values.indexOf(value) === -1) values.push(value);
    }
    return values;
  }

  function hasFieldedQuery(rawQuery) {
    return /\b(?:tag|title|body|vendor|product_type|variants\.sku):/i.test(String(rawQuery || ''));
  }

  function searchTermsFromParams(params) {
    var visibleKeyword = params.get('peta_keyword') || '';
    var rawQuery = params.get('q') || '';
    var tagFilters = visibleKeyword ? [] : fieldValues(rawQuery, 'tag');
    var titleFields = visibleKeyword ? [] : fieldValues(rawQuery, 'title');
    var source = visibleKeyword || rawQuery;
    if (!visibleKeyword && hasFieldedQuery(rawQuery)) {
      source = titleFields.length ? titleFields.join(' ') : rawQuery.replace(/\b(?:tag|body|vendor|product_type|variants\.sku):("[^"]+"|[^\s)]+)/gi, ' ');
    }
    var matchAny = !visibleKeyword && /\sOR\s/i.test(rawQuery);
    source = source
      .replace(QUERY_FIELD_PREFIX, ' ')
      .replace(/\b(?:OR|AND)\b/gi, ' ')
      .replace(/[()"]/g, ' ');

    var normalized = normalize(source);
    var compacted = compact(source);
    return {
      raw: source,
      normalized: normalized,
      compacted: compacted,
      tokens: normalized.split(' ').filter(Boolean),
      compactTokens: normalized.split(' ').filter(Boolean).map(compact).filter(Boolean),
      tagFilters: tagFilters,
      matchAny: matchAny,
    };
  }

  function selectedValues(params, name) {
    return params.getAll(name).map(function(value) { return String(value || '').trim(); }).filter(Boolean);
  }

  function selectedSplitValues(params, name) {
    return params.getAll(name).reduce(function(values, value) {
      String(value || '').split('|').forEach(function(item) {
        var trimmed = item.trim();
        if (trimmed && values.indexOf(trimmed) === -1) values.push(trimmed);
      });
      return values;
    }, []);
  }

  function searchIndexUrl(file) {
    var base = String(config.assetBaseUrl || config.manifestUrl || '');
    if (!base) return file;
    return base.replace(/peta-search-index-manifest\.json(?:\?.*)?$/, file);
  }

  function loadIndex() {
    if (products) return Promise.resolve(products);
    if (loadingPromise) return loadingPromise;
    if (!config.manifestUrl) return Promise.resolve(null);

    loadingPromise = fetch(config.manifestUrl, { credentials: 'same-origin' })
      .then(function(response) {
        if (!response.ok) throw new Error('manifest not found');
        return response.json();
      })
      .then(function(manifest) {
        if (!manifest || manifest.enabled === false || !Array.isArray(manifest.chunks) || !manifest.chunks.length) {
          throw new Error('search index disabled');
        }
        return Promise.all(
          manifest.chunks.map(function(chunk) {
            return fetch(searchIndexUrl(chunk.file), { credentials: 'same-origin' })
              .then(function(response) {
                if (!response.ok) throw new Error(chunk.file + ' not found');
                return response.json();
              })
              .then(function(payload) {
                return Array.isArray(payload.products) ? payload.products : [];
              });
          })
        ).then(function(chunks) {
          products = chunks.reduce(function(all, chunk) { return all.concat(chunk); }, []);
          window.petaSearchIndexActive = true;
          document.documentElement.classList.add('peta-search-index-ready');
          return products;
        });
      })
      .catch(function() {
        products = null;
        window.petaSearchIndexActive = false;
        document.documentElement.classList.remove('peta-search-index-ready');
        return null;
      });

    return loadingPromise;
  }

  function setLoading(isLoading) {
    document.documentElement.classList.toggle('peta-ranked-search-loading', isLoading);
    var container = document.getElementById('ProductGridContainer');
    if (!container) return;
    container.classList.toggle('loading', isLoading);
    if (isLoading) container.setAttribute('aria-busy', 'true');
    else container.removeAttribute('aria-busy');
  }

  function productMatchesQuery(product, query) {
    var tagFilters = Array.isArray(query.tagFilters) ? query.tagFilters : [];
    if (!query.tokens.length && !tagFilters.length) return true;
    var haystack = String(product.s || '');
    var compactHaystack = String(product.sc || '');
    var matcher = function(token, index) {
      return haystack.indexOf(token) !== -1 || compactHaystack.indexOf(query.compactTokens[index] || token) !== -1;
    };
    var textMatchesAny = query.tokens.length ? query.tokens.some(matcher) : false;
    var textMatchesAll = query.tokens.length ? query.tokens.every(matcher) : false;
    var productCategories = Array.isArray(product.cat) ? product.cat : [];
    var tagMatches = tagFilters.length
      ? tagFilters.some(function(tag) { return productCategories.indexOf(tag) !== -1; })
      : false;

    if (query.matchAny) {
      return textMatchesAny || tagMatches;
    }
    if (query.tokens.length && !textMatchesAll) return false;
    if (tagFilters.length && !tagMatches) return false;
    return true;
  }

  function productMatchesFilters(product, params) {
    var types = selectedValues(params, 'filter.p.product_type');
    if (types.length && types.indexOf(product.pt || '') === -1) return false;

    var categories = selectedValues(params, 'filter.p.tag').concat(selectedSplitValues(params, 'peta.category'));
    categories = categories.filter(function(value, index) { return value && categories.indexOf(value) === index; });
    if (categories.length) {
      var productCategories = Array.isArray(product.cat) ? product.cat : [];
      var hasCategory = categories.some(function(category) { return productCategories.indexOf(category) !== -1; });
      if (!hasCategory) return false;
    }

    return true;
  }

  function rankValue(product) {
    return product.r ? product.r : Number.POSITIVE_INFINITY;
  }

  function ascendingPrice(product) {
    return product.p ? product.p : Number.POSITIVE_INFINITY;
  }

  function scoreProduct(product, query) {
    if (!query.tokens.length && !(Array.isArray(query.tagFilters) && query.tagFilters.length)) return 0;
    var title = normalize(product.t);
    var titleCompact = compact(product.t);
    var haystack = String(product.s || '');
    var compactHaystack = String(product.sc || '');
    var score = 0;

    if (query.normalized && title.indexOf(query.normalized) !== -1) score += 80;
    if (query.compacted && titleCompact.indexOf(query.compacted) !== -1) score += 80;

    query.tokens.forEach(function(token, index) {
      var compactToken = query.compactTokens[index] || token;
      if (title === token || titleCompact === compactToken) score += 60;
      else if (title.indexOf(token) === 0 || titleCompact.indexOf(compactToken) === 0) score += 40;
      else if (title.indexOf(token) !== -1 || titleCompact.indexOf(compactToken) !== -1) score += 28;
      else if (haystack.indexOf(token) !== -1 || compactHaystack.indexOf(compactToken) !== -1) score += 8;
    });

    if (Array.isArray(query.tagFilters) && query.tagFilters.length) {
      var productCategories = Array.isArray(product.cat) ? product.cat : [];
      if (query.tagFilters.some(function(tag) { return productCategories.indexOf(tag) !== -1; })) score += 40;
    }

    return score;
  }

  function sortProducts(items, params, query) {
    var sortBy = params.get('sort_by') || 'most-relevant';
    var decorated = items.map(function(product) {
      return { product: product, score: scoreProduct(product, query) };
    });

    decorated.sort(function(a, b) {
      var productA = a.product;
      var productB = b.product;
      if (sortBy === 'price-ascending') return ascendingPrice(productA) - ascendingPrice(productB) || rankValue(productA) - rankValue(productB) || productB.n - productA.n;
      if (sortBy === 'price-descending') return (productB.p || 0) - (productA.p || 0) || rankValue(productA) - rankValue(productB) || productB.n - productA.n;
      if (sortBy === 'created-ascending') return (productA.c || 0) - (productB.c || 0) || rankValue(productA) - rankValue(productB) || productB.n - productA.n;
      if (sortBy === 'created-descending') return (productB.c || 0) - (productA.c || 0) || rankValue(productA) - rankValue(productB) || productB.n - productA.n;
      if (sortBy === 'manual') return rankValue(productA) - rankValue(productB) || productB.n - productA.n || String(productA.h).localeCompare(String(productB.h), 'ja', { numeric: true });
      return b.score - a.score || productB.n - productA.n || String(productA.h).localeCompare(String(productB.h), 'ja', { numeric: true });
    });

    return decorated.map(function(item) { return item.product; });
  }

  function formatMoney(cents) {
    var amount = Math.round(Number(cents || 0) / 100);
    if (!amount) return '';
    return '¥' + amount.toLocaleString('ja-JP');
  }

  function safeImageUrl(url) {
    var text = String(url || '').trim();
    if (!text) return '';
    if (/^https:\/\//i.test(text)) return text;
    if (/^\/\//.test(text)) return 'https:' + text;
    return '';
  }

  function productCard(product) {
    var type = product.pt || 'ステッカー';
    var imageUrl = safeImageUrl(product.img);
    var image = imageUrl
      ? '<img src="' + escapeAttr(imageUrl) + '" loading="lazy" alt="' + escapeAttr(product.t) + '">'
      : '<span class="product-image-fallback">' + escapeHtml(product.t) + '</span>';
    var price = formatMoney(product.p);
    var priceHtml = price ? '<span class="price">' + price + (product.pv ? '~' : '') + '</span>' : '';

    return [
      '<li class="grid__item" data-product-handle="' + escapeAttr(product.h) + '" data-product-type="' + escapeAttr(type) + '" data-product-price="' + escapeAttr(product.p || 0) + '" data-product-created="' + escapeAttr(product.c || 0) + '" data-peta-index-card>',
      '<a class="product-card" href="/products/' + encodeURIComponent(product.h) + '">',
      '<figure>' + image + '</figure>',
      '<div class="product-body">',
      '<span class="badge' + (type.indexOf('プリント') !== -1 ? ' print' : '') + '">' + escapeHtml(type) + '</span>',
      '<h3>' + escapeHtml(product.t) + '</h3>',
      priceHtml,
      '</div>',
      '</a>',
      '</li>',
    ].join('');
  }

  function productJson(handle) {
    if (!handle) return Promise.resolve(null);
    if (productDetailCache[handle]) return productDetailCache[handle];
    productDetailCache[handle] = fetch('/products/' + encodeURIComponent(handle) + '.js', { credentials: 'same-origin' })
      .then(function(response) {
        if (!response.ok) throw new Error('product json not found');
        return response.json();
      })
      .catch(function() { return null; });
    return productDetailCache[handle];
  }

  function hydrateProductCards(list) {
    if (!list) return;
    list.querySelectorAll('[data-peta-index-card]').forEach(function(card) {
      var handle = card.getAttribute('data-product-handle');
      var figure = card.querySelector('figure');
      if (!handle || !figure) return;

      productJson(handle).then(function(detail) {
        if (!detail) return;
        var imageUrl = safeImageUrl(detail.featured_image || (detail.images && detail.images[0]));
        if (imageUrl) {
          figure.innerHTML = '<img src="' + escapeAttr(imageUrl) + '" loading="lazy" alt="' + escapeAttr(detail.title || handle) + '">';
        }

        var priceNode = card.querySelector('.price');
        var price = detail.price_min || detail.price;
        var varies = detail.price_min && detail.price_max && detail.price_min !== detail.price_max;
        if (priceNode && price) priceNode.textContent = formatMoney(price) + (varies ? '~' : '');
      });
    });
  }

  function paginationHtml(page, totalPages, params) {
    if (totalPages <= 1) return '';
    var items = [];
    var start = Math.max(1, page - 2);
    var end = Math.min(totalPages, page + 2);
    if (page > 1) items.push(pageLink(page - 1, params, '前へ', 'pagination__item--prev'));
    if (start > 1) {
      items.push(pageLink(1, params, '1'));
      if (start > 2) items.push('<li><span class="pagination__item">...</span></li>');
    }
    for (var pageNumber = start; pageNumber <= end; pageNumber += 1) {
      items.push(pageLink(pageNumber, params, String(pageNumber), pageNumber === page ? 'pagination__item--current' : ''));
    }
    if (end < totalPages) {
      if (end < totalPages - 1) items.push('<li><span class="pagination__item">...</span></li>');
      items.push(pageLink(totalPages, params, String(totalPages)));
    }
    if (page < totalPages) items.push(pageLink(page + 1, params, '次へ', 'pagination__item--next'));
    return '<nav class="pagination-wrapper" aria-label="Pagination"><ul class="pagination list-unstyled" role="list">' + items.join('') + '</ul></nav>';
  }

  function pageLink(page, params, label, extraClass) {
    var nextParams = new URLSearchParams(params.toString());
    if (page <= 1) nextParams.delete('page');
    else nextParams.set('page', String(page));
    var href = window.location.pathname + '?' + nextParams.toString();
    return '<li><a href="' + escapeAttr(href) + '" class="pagination__item ' + escapeAttr(extraClass || '') + '" data-peta-search-page="' + page + '">' + escapeHtml(label) + '</a></li>';
  }

  function ensureGrid(root) {
    var list = root.querySelector('ul.grid, .grid.product-grid');
    if (list) return list;
    list = document.createElement('ul');
    list.className = 'grid product-grid grid--2-col-tablet-down grid--4-col-desktop';
    list.setAttribute('role', 'list');
    root.appendChild(list);
    return list;
  }

  function updateCount(count) {
    document.querySelectorAll('#ProductCount, #ProductCountDesktop').forEach(function(node) {
      node.textContent = count + '件';
      node.classList.remove('loading');
    });
    document.querySelectorAll('.mobile-facets__count').forEach(function(node) {
      node.textContent = count + '件';
    });
  }

  function setNativeEmptyVisible(isVisible) {
    document.querySelectorAll('[data-peta-native-search-empty], [data-peta-native-grid-empty]').forEach(function(node) {
      node.hidden = !isVisible;
      if (isVisible) node.removeAttribute('aria-hidden');
      else node.setAttribute('aria-hidden', 'true');
    });
  }

  function syncSortControls(params) {
    var sortBy = params.get('sort_by') || 'most-relevant';
    var labels = {
      manual: 'おすすめ順',
      'most-relevant': '関連度順',
      'created-descending': '新着順',
      'created-ascending': '古い順',
      'price-ascending': '安い順',
      'price-descending': '高い順',
    };
    document.querySelectorAll('select[name="sort_by"]').forEach(function(select) {
      if (select.querySelector('option[value="' + sortBy + '"]')) select.value = sortBy;
    });
    document.querySelectorAll('input[name="sort_by"]').forEach(function(input) {
      input.checked = input.value === sortBy;
    });
    document.querySelectorAll('.peta-mobile-sort-current').forEach(function(node) {
      node.textContent = labels[sortBy] || '関連度順';
    });
  }

  function syncSearchInputs(query, params) {
    var displayKeyword = params.get('peta_keyword') || query.raw || '';
    if (!displayKeyword) return;
    document.querySelectorAll('form[role="search"] input[name="q"]').forEach(function(input) {
      input.value = displayKeyword;
    });
  }

  function categoryData() {
    return window.petaCollectionCategoryData || [];
  }

  function labelForCategoryTag(tag) {
    var category = categoryData().find(function(item) {
      return item.tag === tag;
    });
    return category ? category.title : String(tag || '').replace(/^\d+\./, '');
  }

  function removeQueryValue(params, name, value) {
    if (name === 'peta.category') {
      var remainingCategories = selectedSplitValues(params, name).filter(function(item) {
        return item !== value;
      });
      params.delete(name);
      if (remainingCategories.length) params.set(name, remainingCategories.join('|'));
      return;
    }
    var remaining = params.getAll(name).filter(function(item) {
      return item !== value;
    });
    params.delete(name);
    remaining.forEach(function(item) {
      params.append(name, item);
    });
  }

  function filterSummaryUrl(params) {
    params.delete('page');
    var query = params.toString();
    return window.location.pathname + (query ? '?' + query : '');
  }

  function renderActiveFilterSummary() {
    var summary = document.querySelector('[data-peta-active-filter-summary]');
    if (!summary) return;

    var chipsContainer = summary.querySelector('[data-peta-active-filter-chips]');
    var clearLink = summary.querySelector('[data-peta-active-filter-clear]');
    var params = currentParams();
    var chips = [];

    selectedValues(params, 'filter.p.product_type').forEach(function(type) {
      var chipParams = new URLSearchParams(params.toString());
      removeQueryValue(chipParams, 'filter.p.product_type', type);
      chips.push({
        group: 'ステッカー種別',
        label: type,
        url: filterSummaryUrl(chipParams),
      });
    });

    selectedValues(params, 'filter.p.tag').forEach(function(tag) {
      var chipParams = new URLSearchParams(params.toString());
      removeQueryValue(chipParams, 'filter.p.tag', tag);
      chips.push({
        group: 'カテゴリ',
        label: labelForCategoryTag(tag),
        url: filterSummaryUrl(chipParams),
      });
    });

    selectedSplitValues(params, 'peta.category').forEach(function(tag) {
      var chipParams = new URLSearchParams(params.toString());
      removeQueryValue(chipParams, 'peta.category', tag);
      chips.push({
        group: 'カテゴリ',
        label: labelForCategoryTag(tag),
        url: filterSummaryUrl(chipParams),
      });
    });

    if (!chips.length) {
      summary.hidden = true;
      if (chipsContainer) chipsContainer.innerHTML = '';
      return;
    }

    if (chipsContainer) {
      chipsContainer.innerHTML = chips.map(function(chip) {
        return (
          '<a class="peta-active-filter-chip" href="' + escapeAttr(chip.url) + '">' +
            '<span class="peta-active-filter-chip__group">' + escapeHtml(chip.group) + '</span>' +
            '<span class="peta-active-filter-chip__label">' + escapeHtml(chip.label) + '</span>' +
            '<span class="peta-active-filter-chip__remove" aria-hidden="true">×</span>' +
            '<span class="visually-hidden">を解除</span>' +
          '</a>'
        );
      }).join('');
    }

    if (clearLink) {
      var clearParams = new URLSearchParams(params.toString());
      clearParams.delete('filter.p.product_type');
      clearParams.delete('filter.p.tag');
      clearParams.delete('peta.category');
      clearLink.href = filterSummaryUrl(clearParams);
    }

    summary.hidden = false;
  }

  function renderIndexedSearch() {
    var token = ++renderToken;
    var params = currentParams();
    var query = searchTermsFromParams(params);
    syncSearchInputs(query, params);
    renderActiveFilterSummary();
    if (!query.tokens.length && !(Array.isArray(query.tagFilters) && query.tagFilters.length) && !selectedValues(params, 'filter.p.product_type').length && !selectedValues(params, 'filter.p.tag').length && !selectedSplitValues(params, 'peta.category').length) {
      setLoading(false);
      return Promise.resolve(false);
    }

    setLoading(true);
    return loadIndex().then(function(indexProducts) {
      if (token !== renderToken) return false;
      if (!indexProducts) {
        setLoading(false);
        return false;
      }

      var root = document.getElementById('product-grid');
      if (!root) {
        setLoading(false);
        return false;
      }

      var matched = indexProducts.filter(function(product) {
        return productMatchesQuery(product, query) && productMatchesFilters(product, params);
      });
      var sorted = sortProducts(matched, params, query);
      setNativeEmptyVisible(false);
      var page = parseInt(params.get('page') || '1', 10);
      if (!Number.isFinite(page) || page < 1) page = 1;
      var totalPages = Math.max(1, Math.ceil(sorted.length / PRODUCTS_PER_PAGE));
      page = Math.min(page, totalPages);
      var start = (page - 1) * PRODUCTS_PER_PAGE;
      var visible = sorted.slice(start, start + PRODUCTS_PER_PAGE);
      var list = ensureGrid(root);
      var empty = root.querySelector('[data-peta-index-empty]');

      list.innerHTML = visible.map(productCard).join('');
      list.hidden = !visible.length;
      hydrateProductCards(list);

      if (!empty) {
        empty = document.createElement('div');
        empty.className = 'peta-index-empty title-wrapper center';
        empty.setAttribute('data-peta-index-empty', '');
        root.appendChild(empty);
      }
      empty.hidden = Boolean(visible.length);
      empty.innerHTML = '<h2 class="title title--primary">該当する商品が見つかりませんでした。</h2>';

      root.querySelectorAll('.pagination-wrapper').forEach(function(node) { node.remove(); });
      root.insertAdjacentHTML('beforeend', paginationHtml(page, totalPages, params));

      updateCount(sorted.length);
      syncSortControls(params);
      renderActiveFilterSummary();
      setLoading(false);
      return true;
    }).catch(function() {
      renderActiveFilterSummary();
      setLoading(false);
      return false;
    });
  }

  function handlePaginationClick(event) {
    var link = event.target.closest('[data-peta-search-page]');
    if (!link || !products) return;
    event.preventDefault();
    history.pushState({ searchParams: link.href.split('?')[1] || '' }, '', link.href);
    renderIndexedSearch();
  }

  window.petaSearchIndexActive = false;
  window.petaRunIndexedSearch = renderIndexedSearch;
  window.petaRefreshSearchRecommendedSort = function() {
    return renderIndexedSearch().then(function(rendered) {
      if (!rendered && typeof fallbackRefreshSearch === 'function') return fallbackRefreshSearch();
      return rendered;
    });
  };

  document.addEventListener('click', handlePaginationClick);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', renderIndexedSearch, { once: true });
  } else {
    renderIndexedSearch();
  }
})();
